import Vue from 'vue'
import configs from '@/config'
import store from '@/vuex/store'

let resource = null

const actions = {
  createNewGoogleSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/google/slides/`,
  },
  createGoogleSlidePresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/google/presentations/`,
  },
  syncGoogleSlidesViaLiveApi: {
    method: 'POST',
    url: `${configs.baseLiveApiUrl}/api/stream/presenter/sync-google-slide`,
  },
  syncGoogleSlidesPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/google-slide/sync-presentation/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createNewGoogleSlide = (params) => {
  return resource.createNewGoogleSlide(params)
}

const createGoogleSlidePresentation = async (params) => {
  const res = await resource.createGoogleSlidePresentation(params)
  return res.body
}

const syncGoogleSlides = async (params) => {
  if (store.getters.canUseGoogleSlideSyncV2) {
    const res = await resource.syncGoogleSlidesPresentation(params)
    return res.body
  }
  const res = await resource.syncGoogleSlidesViaLiveApi(params)
  return res.body
}

export default {
  initResource,
  createNewGoogleSlide,
  createGoogleSlidePresentation,
  syncGoogleSlides,
}
